<template>
    <div>
        <buttonlist ref="SetBtn" @help="help" @search="search" @exps="exps"></buttonlist>
        <div style="width:100%">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[1974]') }}</td>
                    <td style="width:150px;">
                        <el-select filterable v-model="costyear"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                    <td style="width:60px">{{ $t('getapi[1975]') }}</td>
                    <td style="width:150px;">
                        <el-select filterable v-model="costmonth"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <el-table
                    id="xpane-0"
                    :data="dataSet"
                    ref="singleTable"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="costYear" :label="$t('getapi[1974]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="costMonth" :label="$t('getapi[1975]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[2610]')"></el-table-column>
                <el-table-column prop="amount" :label="$t('getapi[7514]')" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.amount | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column prop="days" :label="$t('getapi[7167]')" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.days | thousandth}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_wipsumasday',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                costyear: '',
                costmonth: '',
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                yearList: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let year = new Date().getFullYear()
            that.yearList.push({
                value: year + 1,
                label: year + 1
            })
            for(let i=0;i<10;i++){
                that.yearList = [...that.yearList,{
                    value: year - i,
                    label: year - i
                }]
            }
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6674]"),this.$t("getapi[6633]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,export');
            },
            getView(){
                let that = this
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth
                }
                that.$http.urlpost('/Fin/Wip/GetWipSumAsDay', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                });
            },
            search(){
                let that = this
                that.getView()
            },
            exps(){
                let that = this;
                that.loading = true;
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[6674]')
                }
                that.$http.urlpost('/Fin/Wip/GetWipSumAsDayToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
